// extracted by mini-css-extract-plugin
module.exports = {"baggageIcon_wrapper":"baggageIcon_wrapper-3O1K2","name":"name-397Vh","size":"size-2idek"};